import React from 'react';
import {FormattedMessage} from 'react-intl';
import {Link, useLocation} from 'react-router-dom';
import searchFilter from '../../../searchFilter';
import Button from '../../../components/button/button';

const FooterAction = ({createImpulse, isLoading, actionDisabled}) => {
    const location = useLocation();
    return (
        <div className='checkout-footer padding-bottom-3dot5rem mw768-padding-bottom-7dot5rem'>
            <Button {...{fluid: 'always', color: 'primary-gradient', size: 'lg', clickHandler: createImpulse, isLoading, disabled: actionDisabled}}> 
                <FormattedMessage defaultMessage='Proceed with ordering'/>
            </Button>
            <div className='padding-top-1dot25rem color-gray-400 text-xs'>
                <FormattedMessage defaultMessage='By clicking Proceed button, you agree to the'/>
                {' '}
                <Link className='color-gray-500 text-decoration-underline' to={`/rules${searchFilter(location.search)}`}><FormattedMessage defaultMessage='Rules'/></Link>
                {' '}
                <FormattedMessage defaultMessage='and' />
                {' '}
                <Link className='color-gray-500 text-decoration-underline' to={`/terms${searchFilter(location.search)}`}><FormattedMessage defaultMessage='Terms of service'/></Link>
                {' '}
                <FormattedMessage defaultMessage='and that you have read the' />
                {' '}
                <Link className='color-gray-500 text-decoration-underline' to={`/privacy${searchFilter(location.search)}`}><FormattedMessage defaultMessage='Privacy policy'/></Link>
            </div>
        </div>
    )
};

export default React.memo(FooterAction);
